import {
  EnrollmentStatus,
  OnboardingPeriodReportDto,
  QualifyingLifeEventType,
} from '@zorro/clients';
import {
  formatDateEnLocaleRangeMMMDayYear,
  formatToMMMDayYear,
} from '@zorro/shared/formatters';
import { qualifyingLifeEventLabelConfig } from '@zorro/types';
import { $enum } from 'ts-enum-util';

type EnrollmentDateInfo = { label: string; value: string | null };

export function getEnrollmentDateInfo(
  onboardingPeriod: OnboardingPeriodReportDto
): EnrollmentDateInfo {
  const { enrollmentStatus, effectiveFrom, effectiveUntil } = onboardingPeriod;

  const expectedCoverage: EnrollmentDateInfo = {
    label: 'Expected start of coverage',
    value: formatToMMMDayYear(effectiveFrom),
  };
  const requestedCoverage: EnrollmentDateInfo = {
    label: 'Requested coverage period',
    value: formatDateEnLocaleRangeMMMDayYear(effectiveFrom, effectiveUntil),
  };
  const coveragePeriod: EnrollmentDateInfo = {
    label: 'Coverage period',
    value: formatDateEnLocaleRangeMMMDayYear(effectiveFrom, effectiveUntil),
  };
  const waiverPeriod: EnrollmentDateInfo = {
    label: 'Waiver effective period',
    value: formatDateEnLocaleRangeMMMDayYear(effectiveFrom, effectiveUntil),
  };
  const notAvailable: EnrollmentDateInfo = { label: 'N/A', value: 'N/A' };

  return $enum.mapValue(enrollmentStatus).with<EnrollmentDateInfo>({
    [EnrollmentStatus.PENDING_ELECTION_WINDOW]: expectedCoverage,
    [EnrollmentStatus.ELECTION_ACTIVE]: expectedCoverage,
    [EnrollmentStatus.ELECTION_ACTIVE_HAS_NOT_STARTED]: expectedCoverage,
    [EnrollmentStatus.ELECTION_ACTIVE_STARTED]: expectedCoverage,
    [EnrollmentStatus.ELECTION_SUBMITTED]: expectedCoverage,
    [EnrollmentStatus.DEADLINE_PASSED]: expectedCoverage,
    [EnrollmentStatus.ENROLLMENT_IN_PROCESS]: requestedCoverage,
    [EnrollmentStatus.ENROLLMENT_CONFIRMED]: coveragePeriod,
    [EnrollmentStatus.ACTIVE_COVERAGE]: coveragePeriod,
    [EnrollmentStatus.COVERAGE_ENDED]: coveragePeriod,
    [EnrollmentStatus.WAIVED_ELECTION]: waiverPeriod,
    [EnrollmentStatus.WAIVED_COVERAGE]: waiverPeriod,
    [EnrollmentStatus.NO_ENROLLMENTS]: notAvailable,
    [$enum.handleUnexpected]: notAvailable,
  });
}

export function getEnrollmentOverviewQleDetails(
  onboardingPeriod: OnboardingPeriodReportDto
): { label: string; date: string; tooltip?: string | null } | null {
  const { qualifyingLifeEvent } = onboardingPeriod;
  if (!qualifyingLifeEvent) {
    return null;
  }

  const label = qualifyingLifeEventLabelConfig[qualifyingLifeEvent.type];
  const date = formatToMMMDayYear(qualifyingLifeEvent.occurredOn);
  const isOtherReason =
    qualifyingLifeEvent.type === QualifyingLifeEventType.OTHER;

  return {
    label,
    date,
    tooltip: isOtherReason ? qualifyingLifeEvent.otherReason : null,
  };
}
